import { format } from "date-fns"
import { DateOnlyFormat } from "@/lib/date-only"
import { RecordExtractFormValues } from "@/modules/patients/detail/record-extract/lib/record-extract-schema"
import { Ch_requestPatientRecordExportInput } from "@/modules/patients/detail/record-extract/services/__generated__/useRequestPatientRecordExportMutation.graphql"
import { EXPORT_SCOPE, PROGRESS_NOTE_TYPE } from "@/modules/patients/detail/record-extract/types/record-extract-types"

export const buildExportInput = (
  patientId: string,
  values: RecordExtractFormValues,
): Ch_requestPatientRecordExportInput => {
  if (values.scope !== EXPORT_SCOPE.custom) {
    return { patientId, period: null, progressNoteKind: null, episodeOfCareIds: [], includeTimeWindows: true }
  }

  const { startDate, endDate, progressNoteType, episodeOfCareIds, timeWindowEnabled } = values

  return {
    patientId,
    period:
      startDate && endDate ? { from: format(startDate, DateOnlyFormat), to: format(endDate, DateOnlyFormat) } : null,
    progressNoteKind: progressNoteType === PROGRESS_NOTE_TYPE.all ? null : progressNoteType,
    episodeOfCareIds,
    includeTimeWindows: timeWindowEnabled,
  }
}
